import React from 'react';
import { useAvailabilities } from '@/hooks/useAvailabilities';

interface TimeSelectorProps {
  selectedDate: string;
  selectedTime: string;
  onTimeSelect: (time: string) => void;
}

const TimeSelector: React.FC<TimeSelectorProps> = ({
  selectedDate,
  selectedTime,
  onTimeSelect,
}) => {
  const { availabilities, isLoading } = useAvailabilities();
  const [availableTimeSlots, setAvailableTimeSlots] = React.useState<string[]>([]);

  React.useEffect(() => {
    const updateTimeSlots = async () => {
      if (selectedDate && availabilities.length > 0) {
        const timeSlots = availabilities.find(availability => availability.id === selectedDate)?.availabilities;
        setAvailableTimeSlots(Object.keys(timeSlots).filter(time => timeSlots[time].available));
      }
    };

    updateTimeSlots();
  }, [selectedDate, availabilities]);

  if (!selectedDate) {
    return (
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h3 className="text-lg font-semibold mb-4">Sélectionnez une date</h3>
        <p className="text-gray-500">Veuillez d'abord sélectionner une date disponible.</p>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <h3 className="text-lg font-semibold mb-4">Sélectionnez un horaire</h3>
      {isLoading ? (
        <div className="flex justify-center items-center h-48">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orcsys-500"></div>
        </div>
      ) : availableTimeSlots.length === 0 ? (
        <p className="text-gray-500">Aucun horaire disponible pour cette date.</p>
      ) : (
        <div className="grid grid-cols-3 gap-2">
          {availableTimeSlots.map((time) => (
            <button
              key={time}
              type="button"
              onClick={() => onTimeSelect(time)}
              className={`p-3 rounded-lg text-center transition-all ${
                selectedTime === time
                  ? 'bg-orcsys-500 text-white shadow-lg scale-105'
                  : 'hover:bg-orcsys-50 hover:scale-105'
              }`}
            >
              {time}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TimeSelector; 